import { formatters } from '@nexelem/utils';

export const priceMask = () => {
  return {
    mask: Number,
    scale: 2,
    decimal: 2,
    padFractionalZeros: true,
    thousandsSeparator: formatters.number.thousandsSeparator,
    radix: formatters.number.radix,
  };
};
